import { useCallback, useMemo, useState } from "react";
import { useObservable } from "micro-observables";

import { currentBlockSelector, setCurrentBlockSelector } from "../../../../../services/stepThree";

const useEditDataSelectorDialog = () => {
    const blockSelector = useObservable(currentBlockSelector);
    const [ dataSelectorIndex, setDataSelectorIndex ] = useState();
    const [ initialValues, setInitialValues ] = useState();

    const handleEditDataSelectorDialogClose = useCallback(
        () => {
            setInitialValues(undefined);
            setDataSelectorIndex(undefined);
        },
        []
    );

    const handleEditSelector = useCallback(
        (selector, index) => {
            setDataSelectorIndex(index);
            setInitialValues(selector);
        },
        []
    );

    const handleDataSelectorSubmit = useCallback(
        (values) => {
            const newBlockSelector = { ...blockSelector };

            newBlockSelector.data_selectors = blockSelector.data_selectors.map((dataSelector, index) => {
                if(dataSelectorIndex === index) {
                    return values;
                }

                return dataSelector;
            });

            setCurrentBlockSelector(newBlockSelector);
            handleEditDataSelectorDialogClose();
        },
        [ blockSelector, dataSelectorIndex, handleEditDataSelectorDialogClose ]
    );

    return useMemo(
        () => ({
            isOpenDataSelectorDialog: !!initialValues,
            initialValuesDataSelectorDialog: initialValues,
            setInitialValuesDataSelector: setInitialValues,
            handleEditSelector,
            handleEditDataSelectorDialogClose,
            handleDataSelectorSubmit
        }),
        [ handleDataSelectorSubmit, handleEditDataSelectorDialogClose, handleEditSelector, initialValues ]
    );
};

export default useEditDataSelectorDialog;
